import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TipoDeMensajeSwal } from 'src/app/models/enums/tipo-de-mensaje-swal';
import { AuthService } from 'src/app/services/auth.service';
import { HttpGenericService } from 'src/app/services/http-generic.service';

@Component({
  selector: 'app-restaurar-contrasena',
  templateUrl: './restaurar-contrasena.component.html',
  styleUrls: ['./restaurar-contrasena.component.css']
})
export class RestaurarContrasenaComponent implements OnInit {

  usuario: string;
  procesando: boolean = false;
  queryParams: any;
  mensaje = '';

  constructor(
    private route: ActivatedRoute,
    private swal: SweetAlertService,
    private httpGenerico: HttpGenericService,
    private router: Router) { }

  ngOnInit() {
    this.route.queryParams.subscribe(c => this.queryParams = c);
  }

  restaurarContrasena() {
    this.procesando = true;
    let modelo = {
      nombreDeUsuario: this.usuario
    }
    this.httpGenerico.post('usuarios/restore', modelo)
    .subscribe(data => {
      this.mensaje = 'Contraseña restablecida exitosamente, le hemos enviado al email que registro con nosotros la nueva contraseña.';
      this.procesando = false;
    }, err => {
      console.log(err);
      this.procesando = false;
    });
  }

}
